(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('ValueGainLossReportController', ValueGainLossReportController);

	ValueGainLossReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state', '$timeout', '$location', '$anchorScroll'];

	function ValueGainLossReportController($window, WineRepository, $log, lodash, $state, $timeout, $location, $anchorScroll){

		/* jshint validthis: true */
		var self = this;

		self.wineGroupedByGainLossNochange = {};
		self.totalBottles = 0;
		self.totalWines = 0;
		self.groupNames = {
			'gain': 'Gains',
			'loss': 'Losses',
			'nochange': 'No change'
		};

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.report = {
			loading: true,
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.jumpTo = jumpTo;

		self.print = print;

		self.updateView = updateView;

		self.initialize = initialize;

		/** initialize */
		initialize();

		/** begin methods */

		function initialize() {

			_resetReport();

			// @todo convert from wine.purchase.price to wine.value
			// we don't need to dig into the purchase, just keep it simply at the value! :)

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine',
							'Size',
							'Bottles In Cellar / On Order',
							'Average Purchase Price',
							'Value',
							'Gain&nbsp;/&nbsp;Loss'
						];

						// add only those in the cellar
						lodash.forEach(wineEntities, function(wine) {
							if (wine.cellar.qty > 0) {
								var avgPurchasePriceFloat = window.numeral(wine.avgPurchasePrice());
								var type = wine.getValueGainType(avgPurchasePriceFloat);
								if (! lodash.isArray(self.wineGroupedByGainLossNochange[type])) {
									self.wineGroupedByGainLossNochange[type] = [];
								}
								self.wineGroupedByGainLossNochange[type].push(wine);
							}
						});

						self.totalBottles = lodash.sum(self.wineGroupedByGainLossNochange, function(wines) {
							return lodash.sum(wines, function(wine) {
								// Bottles: in the celler
								return wine.cellar.qty;
							});
						});

						self.totalWines = lodash.sum(self.wineGroupedByGainLossNochange, function(wines) {
							return wines.length;
						});

						_updateReport();

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});
		}

		function _updateReport() {
			var keyName = 'Group';
			var keyNamePlural = keyName + 's';

			// initialize totals
			var grandTotals = {
				bottlesInCellar: self.totalBottles,
				value: 0,
				groupCount: Object.keys(self.wineGroupedByGainLossNochange).length,
				wines:  self.totalWines
			};

			// @todo convert to an array so we can ensure order
			lodash.forEach(self.wineGroupedByGainLossNochange, function(wines, maxCost) {
				var groupTotals = {
					bottlesInCellar: 0,
					value: 0
				};

				// total value for grouping
				// @todo convert to?
				// combine this with the grand totals?
				groupTotals.value = lodash.sum(wines, function(wine) {
					return wine.cellar.qty * wine.cellar.value;// doesn't work! wine.totalValue; // was `wine.cellar.qty * wine.cellar.value;` which may be more accurate?
				});

				// update grand total value
				grandTotals.value += groupTotals.value;

				var formattedWines = [];

				lodash.forEach(wines, function(wine) {
					var varietal = (wine.varietal && wine.varietal.name) ? wine.varietal.name + ' ' : '';
					var category = (wine.category && wine.category.name) ? wine.category.name : '';
					var type = varietal + category;

					var avgPurchasePriceFloat = window.numeral(wine.avgPurchasePrice());
					var valueGainFormatted = wine.getRelativeGainPercentFormatted(avgPurchasePriceFloat);
					var valueGainClass = wine.getValueGainClass(avgPurchasePriceFloat);

					groupTotals.bottlesInCellar += wine.cellar.qty;

					// data we want to display on a single wine
					formattedWines.push({
						name: wine.getFullName(),
						appelation: wine.getFullAppellation(),
						type: type,
						size: wine.bottleSize.name,
						bottlesInCellar: wine.cellar.qty,
						qtyOnOrder: wine.getOnOrderQty(),
						averagePurchasePrice: $window.numeral(wine.avgPurchasePrice()).format('$0,0[.]00'), // @todo get avg pp
						value: $window.numeral(wine.cellar.value).format('$0,0[.]00'),
						gain: valueGainFormatted,
						gainClass: valueGainClass
					});
				});

				self.report.groups.push({
					groupName: self.groupNames[maxCost],
					bottlesInCellar: groupTotals.bottlesInCellar,
					value: $window.numeral(groupTotals.value).format('$0,0[.]00'),
					wines: formattedWines
				});

			});

			// @todo sort self.report.groups by .groupName
			self.report.totals = [
				// 'GroupName / Wine',
				'Total ' + keyNamePlural + ': ' + grandTotals.groupCount + '<br/>Total wines: ' + grandTotals.wines,
				// 'Size',
				null,
				// 'Bottles',
				'Total Bottles In Cellar: ' + grandTotals.bottlesInCellar,
				// 'Average Cost',
				null,
				// 'Value',
				$window.numeral(grandTotals.value).format('$0,0[.]00'),
				// 'Gain / Loss'
				null
			];

			// hide loading
			self.report.loading = false;
		}

		function updateView() {
			// remove existing groupings
			self.report.groups = [];

			// show loading
			self.report.loading = true;

			// let dom update to show loading
			$timeout(function(){
				// update
				_updateReport();
			});
		}

		function _resetReport() {
			// remove existing groupings
			self.report.groups = [];
			self.wineGroupedByGainLossNochange = {};

			// show loading
			self.report.loading = true;

			// reset totals
			self.totalBottles = 0;
			self.totalWines = 0;
		}

		function jumpTo(id) {
			$location.hash('item-' + id);
			$anchorScroll();
		}

		function print(){
			return $window.print();
		}
	}

})();
